import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NotificationsComponent} from './notification/notifications.component';
import {TranslateModule} from '@ngx-translate/core';
import {MatIconModule} from '@angular/material/icon';
import { AppendToBodyDirective } from '../utils/directive/append-body.directive';

@NgModule({
  declarations: [
    NotificationsComponent
  ],
  exports: [
    NotificationsComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MatIconModule,
    AppendToBodyDirective
  ]
})
export class NotificationModule { }
